import { render, staticRenderFns } from "./ThgTable.vue?vue&type=template&id=68905acc&"
import script from "./ThgTable.vue?vue&type=script&lang=ts&"
export * from "./ThgTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports